module.exports = __webpack_public_path__ + "img/snapchat-logo-white.096e49e8.svg";